import freightMiddleware from './freight/middleware';
import collectMiddleware from './collect/middleware';
import payMiddleware from './pay/middleware';

const feeMiddleware = [freightMiddleware, payMiddleware, collectMiddleware];

export default feeMiddleware;
